import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { LazyAssignRolesPage } from '@confluence/site-settings/entry-points/AssignRolesPage';

const PERMISSIONS_COMBINATIONS_ANALYTICS_SOURCE = 'adminPermissionsCombinations';

export const PermissionsCombinationsRoute = () => <LazyAssignRolesPage />;
PermissionsCombinationsRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: PERMISSIONS_COMBINATIONS_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
